import { isArray, maxBy } from 'lodash'
import { ROLE, ROLE_RATIO, ROLE_MAP } from '../constants/role'
import { URLs } from '../constants/route'

/**
 * Hàm kiểm tra role trả về từ server
 * @param {array} role Một array chứ các role của người dùng
 * @return {boolean}   Trả về true khi role chính xác và ngược lại
 */
function isRoleValid(role) {
  if (!isArray(role)) return false
  for (let index = 0; index < role.length; index++) {
    const element = role[index]
    if (!ROLE.includes(element)) return false
  }
  return true
}

export function getMaxRole(role) {
  return maxBy(role, item => ROLE_RATIO[item])
}

/**
 * Hàm lấy quyền của role truyền vào
 * @param {array} role Một array chưa các role của người dùng
 *
 * @return {object}   Chứa quyền với các page hiện tại bao gồm: method, device type, devices, users. Nếu role không hợp lệ trả về null
 */
export default function getRole(role) {
  if (!isRoleValid(role)) return null
  //Lấy quyền có trọng số cao nhất trong mảng các quyền hiện có
  const maxRole = getMaxRole(role)
  const ADMIN_GROUP = [ROLE_MAP.ADMIN, ROLE_MAP.MANAGER, ROLE_MAP.ADMIN_PARTNER]
  const getPerItem = (
    view = false,
    add = false,
    edit = false,
    isDelete = false
  ) => {
    return {
      view,
      add,
      edit,
      delete: isDelete
    }
  }
  let permission = {
    [URLs.DASHBOARD]: { ...getPerItem() },
    [URLs.METHODS]: getPerItem(),
    [URLs.DEVICE_TYPE]: getPerItem(),
    [URLs.DEVICES]: getPerItem(),
    [URLs.USERS]: getPerItem(),
    [URLs.UPDATESOFTWARE]: getPerItem(),
    [URLs.CONFIG]: getPerItem(),
  }
  if (maxRole === ROLE_MAP.USER) {
    permission[URLs.DASHBOARD] = getPerItem(true, true, true, true)
    permission[URLs.DEVICES] = getPerItem(true, false, false, false)
  }
  if (ADMIN_GROUP.includes(maxRole)) {
    permission[URLs.DASHBOARD] = getPerItem(true, true, true, true)
    permission[URLs.USERS] = getPerItem(true, true, true, true)
    permission[URLs.DEVICES] = getPerItem(true, true, true, true)
    permission[URLs.CONFIG] = getPerItem(true, true, true, true)
    permission[URLs.UPDATESOFTWARE] = getPerItem(true, true, true, true)
  }
  if (maxRole === ROLE_MAP.ADMIN || maxRole === ROLE_MAP.MANAGER) {
    permission[URLs.METHODS] = getPerItem(true, true, true, true)
    permission[URLs.DEVICE_TYPE] = getPerItem(true, true, true, true)
  }
  return permission
}
